export default __webpack_public_path__ + "locales/ru/SocialAuthWelcomeDialog.json?hash=316ebad804afbadbd468616146712971";